import { useRef, useState } from 'react';
import { useNavigate } from 'react-router';
import { Fragment } from 'react/jsx-runtime';
import { Cell } from '@recargas-dominicanas/core/components';
import { formatCurrency } from '@recargas-dominicanas/core/utils';
import { type IBusiness } from '@recargas-dominicanas/core/types';
import { CellIcon, Menu, TableRow } from '@recargas-dominicanas/core/components';
import { MenuOption } from '../../../components/menu-option/menu-option.component';
import { EditBusinessModal } from '../edit-business-modal/edit-business-modal.component';
import { style } from './business-item.module.css';

interface Props {
  business: IBusiness;
  onArchive?: () => void;
}

export function BusinessItem(props: Props) {

  const { business } = props;

  const navigate = useNavigate();

  const menuIconRef = useRef<HTMLDivElement>(null);
  const [openMenu, setOpenMenu] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);

  function handleClick() {
    navigate(`/business/${business.id}`);
  }

  return (
    <Fragment>
      <TableRow
        onClick={handleClick}>
        <Cell className={style.cell} weight='medium' text={business.id}/>
        <Cell className={style.cell} weight='medium' text={business.name}/>
        <Cell className={style.cell} text={business.city}/>
        <Cell className={style.cell} text={business.address}/>
        <Cell className={style.cell} weight='medium' color='green' text={formatCurrency(business.balance)}/>
        <Cell className={style.cell} weight='medium' color='green' text={formatCurrency(business.sales)}/>
        <Cell className={style.cell} weight='medium' color='green' text={formatCurrency(business.profit)}/>
        <CellIcon refIcon={menuIconRef} onClick={() => setOpenMenu(true)}/>
      </TableRow>
      <Menu 
        open={openMenu} 
        anchor={menuIconRef}
        onClose={() => setOpenMenu(false)}>
        <MenuOption
          text='Editar'
          onClick={() => setOpenEditModal(true)}/>
      </Menu>
      <EditBusinessModal
        open={openEditModal}
        business={business}
        onClose={() => setOpenEditModal(false)}/>
    </Fragment>
  );
}
